<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Argon"
      title="Argon"
    >
      <template slot="links">

        <li class="nav-item">

          <hr class="my-3">
          <a href="#"
             style="background-color: transparent"
             class="nav-link">
            <template>
              <i class="ni ni-user-run text-primary"></i>
              Usuário: {{Store.state.name}}
            </template>
          </a>
          <hr class="my-3">
        </li>

        <sidebar-item
          :link="{
            id: '0',
            name: 'Dashboard',
            icon: 'ni ni-chart-bar-32 text-primary',
            path: '/dashboard'
          }"
        />
        <sidebar-item :link="{id: '1',name: 'Análise dos Posts', icon: 'ni ni-chart-pie-35 text-primary', path: '/postAnalytics'}"/>

        <li class="nav-item">
          <a href="#"
             style="background-color: transparent"
             @click="logout"
             class="nav-link">
            <template>
              <i class="ni ni-cloud-download-95 text-primary"></i>
              <span class="nav-link-text"><strong>Logout</strong></span>
            </template>
          </a>
        </li>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import Store from "../store/store";
  export default {
    computed: {
      Store() {
        return Store
      }
    },
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    mounted() {
      const clickItem = sessionStorage.getItem("clickItem");
      sessionStorage.setItem("clickItem", undefined);
      if (clickItem !== undefined) {
        if (clickItem == '0') {
          this.$router.push('/dashboard')
        } else if (clickItem == '1') {
          this.$router.push('/postAnalytics')
        }else if (clickItem == '2') {
          this.$router.push('/login')
        }
      }
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      logout() {
        this.$store.commit('setUserName', "");
        this.$store.commit('setName', "");
        this.$store.commit('setAccessToken', "");
        this.$store.commit('setAuthentication', false);
        this.$router.push('/login');
      }
    }
  };
</script>
<style lang="scss">
</style>
